export enum ContractingStateEnum {
  ContractingStarted = 'CONTRATACAO_INICIADA',
  ContractingDenied = 'CONTRATACAO_NEGADA',
  ProcessingCreditAnalysis = 'PROCESSANDO_ANALISE_CREDITO',
  CreditAnalysisRejected = 'ANALISE_CREDITO_REPROVADA',
  WaitingProposalGeneration = 'AGUARDANDO_GERACAO_PROPOSTA',
  WaitingDocuments = 'AGUARDANDO_DOCUMENTOS',
  WaitingSelfie = 'AGUARDANDO_SELFIE',
  CafRejected = 'CAF_REPROVADA',
  WaitingRegistrationData = 'AGUARDANDO_DADOS_CADASTRAIS',
  CpfBlocked = 'CPF_BLOQUEADO',
  WaitingProposalAcceptance = 'AGUARDANDO_ACEITE_PROPOSTA',
  WaitingTermsAcceptance = 'AGUARDANDO_ACEITES_TERMOS',
  ProcessingAntiFraud = 'PROCESSANDO_ANTIFRAUDE',
  WaitingContractEffectiveness = 'AGUARDANDO_EFETIVACAO_CONTRATO',
  ContractingFinished = 'CONTRATACAO_FINALIZADA',
  ExpiredKey = 'CHAVE_EXPIRADA',
}
